export default __webpack_public_path__ + "static/media/12.890394ab.png";